export default [
    {
        path: '/circulars',
        name: 'circularsList',
        component: () => import(/* webpackChunkName: "circulars" */ '../views/List.vue'),
        props: true,
    },
]